import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ChurnkeyService } from '@app/shared/services/churnkey.service';

/**
 * We pay churnkey based on the revenue we keep when a customer tries to cancel
 * then aborts it. This dialog is shown to a user as a stepping stone between
 * the your plan page "Cancel" button and starting the chunrkey cancellation process
 * to deter us from paying from people who are just clicking around.
 */
@Component({
  standalone: false,
  selector: 'sbnb-dialog-time-saved',
  template: `
    <section class="flex items-center justify-end">
      <sbnb-close [border]="true" (click)="onCloseDialog()"></sbnb-close>
    </section>
    <div class="flex flex-col items-center justify-center" style="gap: 48px;">
      <div>
        <h1 style="margin-bottom: 12px">Are you sure?</h1>
        <h2>You’ll lose all of our time-saving features and automations by canceling...</h2>
      </div>
      <div class="flex flex-col items-center justify-center" style="gap: 12px">
        <div>Average time-saved each month by using Hospitable:</div>
        <div class="raspberry-darker">
          <span class="number">26</span>
          <span class="uot">h</span>
          &nbsp;&nbsp;
          <span class="number">20</span>
          <span class="uot">m</span>
        </div>
      </div>

      <div class="w-full flex items-center justify-between" style="gap: 24px">
        <sbnb-button (click)="onCloseDialog()" type="secondary">Nevermind</sbnb-button>
        <sbnb-button id="enter-cancel-flow" (click)="cancel()" type="primary">I understand</sbnb-button>
      </div>
    </div>
  `,
  styles: [
    `
      @import 'variables';

      .number {
        font-size: 48px;
      }
      .uot {
        font-size: 24px;
        font-weight: 700;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogTimeSavedComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<DialogTimeSavedComponent>,
    private readonly churnkeyService: ChurnkeyService
  ) { }

  ngOnInit(): void { }

  public onCloseDialog() {
    this.dialogRef.close();
  }

  public cancel() {
    this.dialogRef.close();
    this.churnkeyService.show();
  }
}
